<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addOilGun"
        >添加油枪</el-button
      >
    </div>
    <div class="tab-content">
      <el-table :data="oilGunList" style="width: 100%" :max-height="550">
        <el-table-column
          align="left"
          prop="tableName"
          label="油枪号"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="goodsName"
          label="油品"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="addQrCode(scope.row)"
              >小程序码</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="updateActive(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="deleteOilGun(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="oilGunList.length > 0" style="padding-left:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowOilGunEdit,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>添加油枪</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowOilGunEdit = false"
          />
        </div>
        <div class="popup-container">
          <el-form
            ref="oilGunForm"
            :model="oilGunForm"
            :rules="rules"
            label-width="120px"
          >
            <el-form-item label="油品：">
              <el-button
                @click="dialogGoodsSel = true"
                v-if="!confirmList.goodsImage"
                >选择油品</el-button
              >
              <img
                v-else
                :src="confirmList.goodsImage"
                alt=""
                style="width:80px;height:80px;"
              />
            </el-form-item>
            <el-form-item label="油品规格：">
              <div>
                <div class="specification-header flex-row-between">
                  <div class="width25">
                    商品名称
                  </div>
                  <div class="width25">
                    单位
                  </div>
                  <div class="width25">
                    售价
                  </div>
                  <!-- <div class="width25">
                    会员价
                  </div>
                  <div class="width25">
                    库存
                  </div> -->
                  <div class="width25">
                    操作
                  </div>
                </div>
                <div class="specification-body flex-row-between">
                  <div class="width25">{{ confirmList.goodsName }}</div>
                  <div class="width25">{{ confirmList.unit }}</div>
                  <div class="width25">{{ confirmList.retailPrice }}</div>
                  <!-- <div class="width25">{{ confirmList.memberPrice }}</div>
                  <div class="width25">{{ confirmList.totalStockCount }}</div> -->
                  <div
                    class="width25 del"
                    v-show="confirmList.retailPrice"
                    @click="deleteGoods"
                  >
                    删除
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="油枪号：" prop="tableName">
              <el-input
                v-model="oilGunForm.tableName"
                placeholder="请输入油枪号"
                :maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submit" :loading="isSubmit">{{
                oilGunForm.shoppingTableId ? "编辑" : "添加"
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <dialog-sel-goods
      :isShow="dialogGoodsSel"
      @hideSelGoods="hideSelGoods"
      @confirmSelGoods="confirmSelGoods"
    ></dialog-sel-goods>
    <div
      class="popup"
      :class="{
        show: isShowUrlQrcode,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>小程序码</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowUrlQrcode = false"
          />
        </div>
        <div class="popup-container">
          <qrcode
            :value="urlQrcode"
            :options="{ size: 300 }"
            class="qrcode"
          ></qrcode>
          <el-button type="primary" @click="downPayCode"
            >下载小程序码</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOilGunList,
  getOilGunListCount,
  deleteOilGun,
  updateOilGun,
  uniformQrCode,
  addQrCodeJumpTableNumber,
} from "../api/index";
import dialogSelGoods from "@/components/dialogSelGoods.vue";
import qrcode from "@xkeshi/vue-qrcode";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      oilGunList: [],
      confirmList: {},
      isShowOilGunEdit: false,
      dialogGoodsSel: false,
      oilGunForm: {
        shoppingTableId: "",
        tableName: "",
        goodsId: "",
        productId: "",
      },
      rules: {
        tableName: [
          { required: true, message: "请输入油枪号", trigger: "blur" },
        ],
        goodsId: [{ required: true, message: "请选择油品", trigger: "blur" }],
      },
      isSubmit: false,
      isShowUrlQrcode: false,
      urlQrcode: "",
    };
  },
  components: {
    dialogSelGoods,
    qrcode,
  },
  mounted() {
    this.getOilGunList();
  },
  methods: {
    getOilGunList() {
      getOilGunList({
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        if (res.code == 1) {
          this.oilGunList = res.data;
        } else if (res.code == -1) {
          this.oilGunList = [];
        }
      });
      getOilGunListCount({
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        if (res.code == 1) {
          this.total = res.data;
        } else {
          this.total = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getOilGunList();
    },
    addOilGun() {
      this.oilGunForm = {
        shoppingTableId: "",
        tableName: "",
        goodsId: "",
        productId: "",
      };
      this.confirmList = {};
      this.isShowOilGunEdit = true;
    },
    lookDetail(row) {
      console.log(row, "lookDetail");
    },
    updateActive(row) {
      console.log(row, "updateActive");
      this.oilGunForm = JSON.parse(JSON.stringify(row));
      this.confirmList = JSON.parse(JSON.stringify(row));
      this.isShowOilGunEdit = true;
    },
    deleteOilGun(row) {
      console.log(row, "deleteOilGun");
      this.$confirm("此操作将永久删除该油枪, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteOilGun({
          shoppingTableId: row.shoppingTableId,
          goodsId: row.goodsId,
          productId: row.productId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getOilGunList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    submit() {
      console.log(this.goodsForm);
      this.isSubmit = true;
      // return
      if (!this.confirmList.goodsId) {
        this.$notify({
          title: "提示",
          message: "请选择油品",
          type: "warning",
          duration: 1000,
        });
        this.isSubmit = false;
        return;
      }
      this.$refs.oilGunForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          this.isSubmit = false;
          return;
        }
      });
      updateOilGun({
        shoppingTableId: this.oilGunForm.shoppingTableId,
        goodsId: this.confirmList.goodsId,
        productId: this.confirmList.productId,
        tableName: this.oilGunForm.tableName,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: `${
              this.oilGunForm.shoppingTableId ? "修改成功" : "新增成功"
            }`,
            type: "success",
            duration: 1000,
          });
          this.isShowOilGunEdit = false;
          this.getOilGunList();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 1000,
          });
        }
        this.isSubmit = false;
      });
    },
    deleteGoods() {
      this.confirmList = {};
    },
    confirmSelGoods(confirmList) {
      this.hideSelGoods();
      this.confirmList = confirmList;
    },
    hideSelGoods() {
      this.dialogGoodsSel = false;
    },
    addQrCode(row) {
      uniformQrCode({
        mtype: 3,
        moreQrParams: `qrcodeValue=${localStorage.shopId +
          "-" +
          String(row.shoppingTableId)}`,
      }).then((res) => {
        if (res.code == 1) {
          this.urlQrcode = res.data.url;
          this.isShowUrlQrcode = true;
        } else {
          // this.$notify({
          //   title: "提示",
          //   message: res.msg,
          //   type: "error",
          //   duration: 2000,
          // });
          addQrCodeJumpTableNumber({
            qrCodeValue: `=${localStorage.shopId +
              "-" +
              String(row.shoppingTableId)}`,
          }).then((res) => {
            if (res.code == 1) {
              this.urlQrcode = res.data.url;
              this.isShowUrlQrcode = true;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    downPayCode() {
      let canvas = document.querySelector(".qrcode");
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = this.qrcodeType == "Qrcode.png"; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
  .popup {
    z-index: 1000;
    .popup-content {
      width: 600px;
      .specification-header {
        display: flex;
        height: 40px;
        background: #f8f8f8;
        padding: 0 10px;
        color: #606266;
        font-size: 12px;
      }
      .specification-body {
        display: flex;
        height: auto;
        border: 1px solid #ececec;
        border-top: none;
        padding: 0 10px;
        line-height: 40px;
      }
      .width25 {
        flex: 1;
        text-align: center;
      }
      .del {
        cursor: pointer;
        color: red;
      }
      .el-form {
        width: 500px;
      }
    }
  }
}
</style>
